const Constant = {
  splitJunctionContainerId: 'split_junction',
  splitJunctionPinId: 'pin',
  splitJunctionHeight: 120,
  splitJunctionWidth: 80,
};

export default Constant;
